


































































import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter, State} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {User} from 'firebase'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';

@Component({
    components: {BDropdown, BDropdownItem},
})
export default class AdminNavBar extends Vue {
    @Prop(String) public readonly path!: string;
    @State('self', {namespace: 'userState'}) public self: MAFUser | undefined;
    @State('currentUser') public currentUser: User | undefined;
    @Getter('getUserImgURL')  public getUserImgURL: any;
}
